import jQuery from 'jquery';
import { ISkipToMainController } from './skip-to-main.interface';

export class SkipToMainController implements ISkipToMainController {
  public focusOnMainContent(): void {
    jQuery('.possible-first-main-focus')[0].focus();
  }
}
